/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import { observable, action } from 'mobx';
import BaseDialog from './baseDialog';
import AppInformation from '../../components/appInformation';

// Details on properties captured in wiki page: https://wiki.corp.adobe.com/display/ccd/App+PDP+Model#AppPDPModel-AppInformationDialog
export default class AppInformationDialog extends BaseDialog {
    app; // App type of object

    /**
     * compatibility                        information for compatibility section
     * compatibility.actionId               actionId for selecting this tab
     * compatibility.tabId                  id of this section
     * compatibility.tabItems               tabs shown inside the compatibility section
     * compatibility.failingSpecsList       list of specs failing for the given machine
     */
    @observable compatibility;

    /**
     * languages                            information for supported languages section
     * languages.actionId                   actionId for selecting this tab
     * languages.tabId                      id of this section
     * languages.languageList               list of supported languages
     * languages.subText                    information to manage language settings
     */
    @observable languages;

    /**
     * version                              information for version section
     * version.actionId                     actionId for selecting this tab
     * version.tabId                        id of this section
     * version.currentVersion               list of current version apps
     * version.previousVersions             list of previous version apps
     * version.subText                      information for the older versions of the apps
     */
    @observable version;

    /**
     * Array of possible actions
     */
    @observable actionList;

    @observable defaultSelectedTabId;

    /**
     * Callback to be executed when any action taken on the dialog
     * @type {function}
     */
    onAction;

    tabSelectActionId

    @action setCompatibility(compatibility) {
        this.compatibility = compatibility;
    }

    @action setLanguages(languages) {
        this.languages = languages;
    }

    @action setVersion(version) {
        this.version = version;
    }

    @action setActionList(actionList) {
        this.actionList = actionList;
    }

    @action setDefaultSelectedTabId(defaultSelectedTabId) {
        this.defaultSelectedTabId = defaultSelectedTabId;
    }

    constructor({
        compatibility, languages, version, defaultSelectedTabId,
        actionList, onAction, app,
    }) {
        super();
        this.compatibility = compatibility;
        this.languages = languages;
        this.version = version;
        this.actionList = actionList;
        this.defaultSelectedTabId = defaultSelectedTabId;
        this.onAction = onAction;
        this.app = app;
    }

    get dialogConfig() {
        return {
            render: () => <AppInformation data={this} />,
            className: 'information-modal-dialog',
        };
    }
}
